import { Box, Center, Text } from '@chakra-ui/react';
import ArticleListItemCard from 'presentation/components/modules/articles/ArticleListItemCard';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  articles: ArticleListItem[];
}

const PeArticles: FC<Props> = ({ articles }) => {
  const { t } = useTranslation();

  if (articles.length === 0) {
    return (
      <AppCard p="20px">
        <Center>
          <Text>{t('listIsEmpty')}</Text>
        </Center>
      </AppCard>
    );
  }

  return (
    <>
      {articles.map((article, index) => {
        let color: string;
        if (index % 3 === 2) {
          color = '#210061';
        } else if (index % 3 === 1) {
          color = '#393939';
        } else {
          color = '#26925f';
        }

        return (
          <Box key={index} mb={index < articles.length - 1 ? '20px' : '0'}>
            <ArticleListItemCard
              article={article}
              color={color}
            />
          </Box>
        );
      })}
    </>
  );
};

export default PeArticles;
